export default "__VITE_ASSET__BswzUX0U__"